import { AmountPrintingPolicy } from "constants/document/AmountPrintingPolicy";
import { DocumentIssuanceConstant } from "presentation/constant/DocumentIssuance/DocumentIssuanceConstant";
import { useDocumentIssuanceVM } from "presentation/hook/DocumentIssuance/useDocumentIssuanceVM";
import { useANAInfoTracked } from "presentation/store/ANAInfo";
import { useDocumentIssuanceTracked } from "presentation/store/DocumentIssuance/DocumentIssuanceProvider";
import { CriteriaItemContainer } from "presentation/view/components/CriteriaItemContainer";
import { NbisCommonField } from "presentation/view/components/NbisCommonField";
import NumberInputComponent from "presentation/view/components/NumberInputComponent";
import { useCallback, useEffect, useMemo, useState } from "react";
import { FieldType, HPHCheckbox, IFieldValue, Loader } from "veronica-ui-component/dist/component/core";
import { SidebarCaption, StyledSidebar } from "veronica-ui-component/dist/component/core/styled/uiFramework.styled";
import DocumentIssuanceEditPanelTitleBar from "../DocumentIssuanceEditPanelTitleBar";

export const DocumentIssuanceHeaderFormPanel = () => {
    const [documentIssuanceState, setDocumentIssuanceState] = useDocumentIssuanceTracked();
    const documentIssuanceVM = useDocumentIssuanceVM();
    const { currentSelectedRow, masterState, dynamicOptions } = documentIssuanceState;
    const { editingEntity, isAdd, isEditable, isRead, isSaveClicked, allFormState, companyCode, customerCode } = masterState;
    const SCREEN_CONSTANT = DocumentIssuanceConstant;
    const [anainfoState] = useANAInfoTracked();
    const { operatingUnit } = anainfoState;

    const currentEntity = isRead ? currentSelectedRow : editingEntity;
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        if (isAdd || isEditable) {
            const initialScreen = async () => {
                setIsLoading(true);
                try {
                    /*const results = await Promise.allSettled([
                        documentIssuanceVM.loadDropdownOption(),
                    ]);
                    results?.forEach((result, index) => {
                        if (index === 0 && result.status === 'fulfilled') {

                        }
                    });*/

                    setDocumentIssuanceState(prevState => {
                        return {
                            ...prevState,
                            masterState: {
                                ...prevState.masterState,
                                editingEntity: {
                                    ...prevState.masterState.editingEntity,
                                    ...((operatingUnit === 'OICT' || operatingUnit === 'HPJZ') ? {
                                        invoiceCurrency: prevState.dynamicOptions?.invoiceCurrencyDropdownOptions?.sort((a, b) => a?.dropdownLabel!.localeCompare(b?.dropdownLabel!))?.[0]?.value ?? '',
                                        docLanguage: prevState.dynamicOptions?.languageDropdownOptions?.filter(item => item.dropdownLabel === 'en')?.sort((a, b) => a?.dropdownLabel!.localeCompare(b?.dropdownLabel!))?.[0]?.value ?? '',
                                        reportId: prevState.dynamicOptions?.reportTemplateDropdownOptions?.sort((a, b) => a?.dropdownLabel!.localeCompare(b?.dropdownLabel!))?.[0]?.value ?? '',
                                    } : {})
                                }
                            },
                        }
                    });
                } catch (error) {
                    setIsLoading(false);
                }
            }
            initialScreen().then(async () => {
                setIsLoading(false)
            }).catch(error => {
                setIsLoading(false)
            });
        }

    }, [documentIssuanceVM, isAdd, isEditable, operatingUnit, setDocumentIssuanceState])

    const onNumberFieldChange = useCallback((e: any, fieldName: string, fieldValue: any) => {
        documentIssuanceVM.onFieldChange(fieldName, fieldValue);
    }, [documentIssuanceVM]);

    const unlanguageDropdownOptions = useMemo(() => {
        return dynamicOptions.languageDropdownOptions?.filter(item => item.dropdownLabel === 'en')
    }, [dynamicOptions.languageDropdownOptions])

    //init default value
    // useEffect(() => {
    //     if(isAdd) {
    //         if(dynamicOptions?.invoiceCurrencyDropdownOptions && dynamicOptions?.invoiceCurrencyDropdownOptions.length > 0) {
    //             const defaultValue = {
    //                 invoiceCurrency: dynamicOptions.invoiceCurrencyDropdownOptions[0]?.value
    //             }
    //             documentIssuanceVM.initDefaultValue(defaultValue);
    //         }
    //     }
    // },[documentIssuanceVM, dynamicOptions?.invoiceCurrencyDropdownOptions, isAdd])

    // useEffect(() => {
    //     if(isAdd) {
    //         if(unlanguageDropdownOptions && unlanguageDropdownOptions.length > 0) {
    //             const defaultValue = {
    //                 docLanguage: unlanguageDropdownOptions[0]?.value
    //             }
    //             documentIssuanceVM.initDefaultValue(defaultValue);
    //         }
    //     }
    // },[documentIssuanceVM, unlanguageDropdownOptions, isAdd])

    // useEffect(() => {
    //     if(isAdd) {
    //         if(dynamicOptions?.reportTemplateDropdownOptions && dynamicOptions?.reportTemplateDropdownOptions.length > 0) {
    //             const defaultValue = {
    //                 reportId: dynamicOptions?.reportTemplateDropdownOptions[0]?.tagLabel
    //             }
    //             documentIssuanceVM.initDefaultValue(defaultValue);
    //         }
    //     }
    // },[documentIssuanceVM, dynamicOptions?.reportTemplateDropdownOptions, isAdd])

    const memoBillToCompany = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "300px", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={!isAdd}
                isShowOptional={true}
                isMultipleDropDown={false}
                readOnlyValue={companyCode ?? ''}
                fieldValue={companyCode ?? ''}
                fieldLabel={SCREEN_CONSTANT.BILL_TO_COMPANY}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'billToCompanyId'}
                isShowMissingError={true}
                maxLength={10}
                isLimitOptions={true}
                options={dynamicOptions.billToCompanyDropdownOptions}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    documentIssuanceVM.onFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [allFormState, isAdd, dynamicOptions.billToCompanyDropdownOptions, SCREEN_CONSTANT.BILL_TO_COMPANY, isSaveClicked, companyCode, documentIssuanceVM])

    const memoCustomerCode = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "300px", marginBottom: "24px" }}>

            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={!isAdd}
                isShowOptional={true}
                isMultipleDropDown={false}
                readOnlyValue={customerCode ?? ''}
                fieldValue={customerCode ?? ''}
                fieldLabel={SCREEN_CONSTANT.CUSTOMER_CODE}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'customerId'}
                isShowMissingError={true}
                maxLength={10}
                options={dynamicOptions.customerCodeDropdownOptions}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    documentIssuanceVM.onFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [allFormState, isAdd, dynamicOptions.customerCodeDropdownOptions, SCREEN_CONSTANT.CUSTOMER_CODE, isSaveClicked, customerCode, documentIssuanceVM])

    const memoChargeType = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "300px", marginBottom: "24px" }}>

            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={!isAdd}
                isShowOptional={true}
                isMultipleDropDown={false}
                readOnlyValue={currentEntity?.chargeType ?? ''}
                fieldValue={currentEntity?.chargeType ?? ''}
                fieldLabel={SCREEN_CONSTANT.CHARGE_TYPE}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'chargeType'}
                isShowMissingError={true}
                maxLength={10}
                options={dynamicOptions.chargeTypeDropdownOptions}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    documentIssuanceVM.onFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [allFormState, isAdd, currentEntity?.chargeType, SCREEN_CONSTANT.CHARGE_TYPE, isSaveClicked, dynamicOptions.chargeTypeDropdownOptions, documentIssuanceVM])

    const memoIssueType = useMemo(() => {
        let issueTypeOptions = dynamicOptions.issueTypeDropdownOptions?.filter(item => operatingUnit === 'ECT' ? true : item.value !== 'E-INVOICE' && item.value !== 'P-PRINT');
        return (<div className='im-flex-row-item' style={{ width: "630px", marginBottom: "24px" }}>

            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={isRead}
                isShowOptional={false}
                isMultipleDropDown={true}
                readOnlyValue={currentEntity?.issueType ?? ""}
                fieldValue={currentEntity?.issueType?.toString().split(";").filter(item => item.trim() !== '') ?? ''}
                fieldLabel={SCREEN_CONSTANT.ISSUE_TYPE}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'issueType'}
                isShowMissingError={true}
                maxLength={10}
                options={issueTypeOptions}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    documentIssuanceVM.onFieldChange(fieldKey, fieldValue && fieldValue as string[], fFullValue)} />
        </div>)
    }
        , [allFormState, isRead, currentEntity?.issueType, SCREEN_CONSTANT.ISSUE_TYPE, isSaveClicked, dynamicOptions.issueTypeDropdownOptions, documentIssuanceVM, operatingUnit])

    const memoDocType = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "300px", marginBottom: "24px" }}>

            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={!isAdd}
                isShowOptional={true}
                isMultipleDropDown={false}
                readOnlyValue={currentEntity?.docType ?? ''}
                fieldValue={currentEntity?.docType ?? ''}
                fieldLabel={SCREEN_CONSTANT.DOC_TYPE}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'docType'}
                isShowMissingError={true}
                maxLength={10}
                options={dynamicOptions.docTypeDropdownOptions}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    documentIssuanceVM.onFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [allFormState, isAdd, currentEntity?.docType, SCREEN_CONSTANT.DOC_TYPE, isSaveClicked, dynamicOptions.docTypeDropdownOptions, documentIssuanceVM])

    const memoNoOfCopies = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "300px", marginBottom: "24px" }}>

            <NumberInputComponent
                label={SCREEN_CONSTANT.NO_OF_COPIES}
                maxLength={10}
                disabled={isRead}
                width='300px'
                fieldName={"noOfCopy"}
                value={currentEntity?.noOfCopy ?? ''}
                errorMessage={allFormState?.noOfCopy}
                //decimalPlaces={2}
                onChange={(e: any, fieldKey: string, fieldValue: any) => onNumberFieldChange(e, fieldKey, fieldValue)}
            />
        </div>
        , [SCREEN_CONSTANT.NO_OF_COPIES, isRead, currentEntity?.noOfCopy, allFormState?.noOfCopy, onNumberFieldChange])

    const memoNoOfOriginal = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "300px", marginBottom: "24px" }}>

            <NumberInputComponent
                label={SCREEN_CONSTANT.NO_OF_ORIGINAL}
                maxLength={10}
                disabled={isRead}
                width='300px'
                fieldName={"noOfOriginal"}
                value={currentEntity?.noOfOriginal ?? ''}
                errorMessage={allFormState?.noOfOriginal}
                //decimalPlaces={2}
                onChange={(e: any, fieldKey: string, fieldValue: any) => onNumberFieldChange(e, fieldKey, fieldValue)}
            />
        </div>
        , [SCREEN_CONSTANT.NO_OF_ORIGINAL, isRead, currentEntity?.noOfOriginal, allFormState?.noOfOriginal, onNumberFieldChange])

    const memoNoOfSupportingDoc = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "300px", marginBottom: "24px" }}>

            <NumberInputComponent
                label={SCREEN_CONSTANT.NO_OF_SUPPORTING_DOC}
                maxLength={10}
                disabled={isRead}
                width='300px'
                optional={true}
                fieldName={"noOfSupportingDoc"}
                value={currentEntity?.noOfSupportingDoc ?? ''}
                errorMessage={allFormState?.noOfSupportingDoc}
                //decimalPlaces={2}
                onChange={(e: any, fieldKey: string, fieldValue: any) => onNumberFieldChange(e, fieldKey, fieldValue)}
            />
        </div>
        , [SCREEN_CONSTANT.NO_OF_SUPPORTING_DOC, isRead, currentEntity?.noOfSupportingDoc, allFormState?.noOfSupportingDoc, onNumberFieldChange])

    const memoAsteriskLabel = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "300px", marginBottom: "24px" }}>

            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={isRead}
                isShowOptional={false}
                isMultipleDropDown={false}
                readOnlyValue={currentEntity?.asteriskLabel ?? ''}
                fieldValue={currentEntity?.asteriskLabel ?? ''}
                fieldLabel={SCREEN_CONSTANT.ASTERISK_LABEL}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'asteriskLabel'}
                isShowMissingError={true}
                maxLength={10}
                options={dynamicOptions.indDropdownOptions}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    documentIssuanceVM.onFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [allFormState, isRead, currentEntity?.asteriskLabel, SCREEN_CONSTANT.ASTERISK_LABEL, isSaveClicked, dynamicOptions.indDropdownOptions, documentIssuanceVM])

    const memoLanguage = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "300px", marginBottom: "24px" }}>

            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={isRead}
                isShowOptional={false}
                isMultipleDropDown={false}
                readOnlyValue={currentEntity?.docLanguage ?? ''}
                fieldValue={currentEntity?.docLanguage ?? ''}
                fieldLabel={SCREEN_CONSTANT.LANGUAGE}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'docLanguage'}
                isShowMissingError={true}
                maxLength={10}
                options={unlanguageDropdownOptions}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    documentIssuanceVM.onFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [allFormState, isRead, currentEntity?.docLanguage, SCREEN_CONSTANT.LANGUAGE, isSaveClicked, documentIssuanceVM, unlanguageDropdownOptions])

    const memoAmountPrinting = useMemo(() => {

        let amountPrintingOptions = dynamicOptions.amountPrintingDropdownOptions?.filter(item => operatingUnit === 'SAPT' || operatingUnit === 'KICT' ? item.value === AmountPrintingPolicy.NORMAL : true);
        return (<div className='im-flex-row-item' style={{ width: "300px", marginBottom: "24px" }}>

            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={isRead}
                isShowOptional={false}
                isMultipleDropDown={false}
                readOnlyValue={currentEntity?.amountPrinting ?? ''}
                fieldValue={currentEntity?.amountPrinting ?? ''}
                fieldLabel={SCREEN_CONSTANT.AMOUNT_PRINTING}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'amountPrinting'}
                isShowMissingError={true}
                maxLength={10}
                options={amountPrintingOptions}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    documentIssuanceVM.onFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>)
    }
        , [allFormState, isRead, currentEntity?.amountPrinting, SCREEN_CONSTANT.AMOUNT_PRINTING, isSaveClicked, dynamicOptions.amountPrintingDropdownOptions, documentIssuanceVM, operatingUnit])

    const memoDisplayBillingMsg = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "300px", marginBottom: "24px" }}>

            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={isRead}
                isShowOptional={false}
                isMultipleDropDown={false}
                readOnlyValue={currentEntity?.displayBillingMsg ?? ''}
                fieldValue={currentEntity?.displayBillingMsg ?? ''}
                fieldLabel={SCREEN_CONSTANT.DISPLAY_BILLING_MSG}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'displayBillingMsg'}
                isShowMissingError={true}
                maxLength={10}
                options={dynamicOptions.indDropdownOptions}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    documentIssuanceVM.onFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [allFormState, isRead, currentEntity?.displayBillingMsg, SCREEN_CONSTANT.DISPLAY_BILLING_MSG, isSaveClicked, dynamicOptions.indDropdownOptions, documentIssuanceVM])

    const memoDisplay2ndCurrency = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "300px", marginBottom: "24px" }}>

            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={isRead}
                isShowOptional={false}
                isMultipleDropDown={false}
                readOnlyValue={currentEntity?.display2ndCurrency ?? ''}
                fieldValue={currentEntity?.display2ndCurrency ?? ''}
                fieldLabel={SCREEN_CONSTANT.DISPLAY_2ND_CURRENCY}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'display2ndCurrency'}
                isShowMissingError={true}
                maxLength={10}
                options={dynamicOptions.indDropdownOptions}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    documentIssuanceVM.onFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [allFormState, isRead, currentEntity?.display2ndCurrency, SCREEN_CONSTANT.DISPLAY_2ND_CURRENCY, isSaveClicked, dynamicOptions.indDropdownOptions, documentIssuanceVM])

    const memoEmailAddress = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "300px", marginBottom: "24px" }}>

            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={isRead}
                isShowOptional={true}
                isMultipleDropDown={false}
                readOnlyValue={currentEntity?.emailAddress ?? ''}
                fieldValue={currentEntity?.emailAddress ?? ''}
                fieldLabel={SCREEN_CONSTANT.EMAIL_ADDRESS}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.TEXT}
                fieldKey={'emailAddress'}
                isShowMissingError={true}
                maxLength={50}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    documentIssuanceVM.onFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [allFormState, isRead, currentEntity?.emailAddress, SCREEN_CONSTANT.EMAIL_ADDRESS, isSaveClicked, documentIssuanceVM])

    const memoCc = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "300px", marginBottom: "24px" }}>

            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={isRead}
                isShowOptional={true}
                isMultipleDropDown={false}
                readOnlyValue={currentEntity?.copyTo ?? ''}
                fieldValue={currentEntity?.copyTo ?? ''}
                fieldLabel={SCREEN_CONSTANT.CC}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.TEXT}
                fieldKey={'copyTo'}
                isShowMissingError={true}
                maxLength={200}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    documentIssuanceVM.onFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [allFormState, isRead, currentEntity?.copyTo, SCREEN_CONSTANT.CC, isSaveClicked, documentIssuanceVM])

    const memoEdiEmailAddress = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "300px", marginBottom: "24px" }}>

            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={isRead}
                isShowOptional={true}
                isMultipleDropDown={false}
                readOnlyValue={currentEntity?.ediEmailAddress ?? ''}
                fieldValue={currentEntity?.ediEmailAddress ?? ''}
                fieldLabel={SCREEN_CONSTANT.EDI_EMAIL_ADDRESS}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.TEXT}
                fieldKey={'ediEmailAddress'}
                isShowMissingError={true}
                maxLength={50}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    documentIssuanceVM.onFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [allFormState, isRead, currentEntity?.ediEmailAddress, SCREEN_CONSTANT.EDI_EMAIL_ADDRESS, isSaveClicked, documentIssuanceVM])

    const memoReportTemplate = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "300px", marginBottom: "24px" }}>

            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={isRead}
                isShowOptional={false}
                isMultipleDropDown={false}
                //readOnlyValue={currentEntity?.reportId ?? ''}
                //fieldValue={currentEntity?.reportId ?? ''}
                readOnlyValue={dynamicOptions.reportTemplateDropdownOptions?.find(item => item.tagLabel === currentEntity?.reportId)?.value ?? currentEntity?.reportId}
                fieldValue={dynamicOptions.reportTemplateDropdownOptions?.find(item => item.tagLabel === currentEntity?.reportId)?.value ?? currentEntity?.reportId}
                fieldLabel={SCREEN_CONSTANT.REPORT_TEMPLATE}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'reportId'}
                isShowMissingError={true}
                maxLength={10}
                options={dynamicOptions.reportTemplateDropdownOptions}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    documentIssuanceVM.onFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [allFormState, isRead, currentEntity?.reportId, SCREEN_CONSTANT.REPORT_TEMPLATE, isSaveClicked, dynamicOptions.reportTemplateDropdownOptions, documentIssuanceVM])

    const memoInvoiceCurrency = useMemo(() => {
        return (<div className='im-flex-row-item' style={{ width: "300px", marginBottom: "24px" }}>

            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={isRead}
                isShowOptional={false}
                isMultipleDropDown={false}
                readOnlyValue={currentEntity?.invoiceCurrency ?? ''}
                fieldValue={currentEntity?.invoiceCurrency ?? ''}
                fieldLabel={SCREEN_CONSTANT.INVOICE_CURRENCY}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'invoiceCurrency'}
                isShowMissingError={true}
                maxLength={10}
                options={dynamicOptions.invoiceCurrencyDropdownOptions}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    documentIssuanceVM.onFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>)
    }
        , [allFormState, isRead, currentEntity?.invoiceCurrency, SCREEN_CONSTANT.INVOICE_CURRENCY, isSaveClicked, dynamicOptions.invoiceCurrencyDropdownOptions, documentIssuanceVM])


    const memoActiveInd = useMemo(() =>
        <>
            <div className='im-flex-row-item' style={{ width: "300px", marginBottom: "24px" }}>

                <NbisCommonField
                    fieldKey={"activeInd"}
                    requiredFieldList={[]}
                    fieldLabel={SCREEN_CONSTANT.ACTIVE_IND}
                    fieldType={FieldType.TEXT}
                    isReadOnly={true}
                    onFieldChange={() => { }} />
                <HPHCheckbox
                    label={""}
                    checked={currentEntity?.activeInd === "N" ? false : true}
                    disabled={isRead}
                    onChange={(e) => documentIssuanceVM.onCheckboxChange(e.checked, "activeInd")}
                />
            </div>
        </>
        , [SCREEN_CONSTANT.ACTIVE_IND, currentEntity?.activeInd, isRead, documentIssuanceVM])

    const memoEditPanelTitleBar = useMemo(() => {
        return <DocumentIssuanceEditPanelTitleBar />
    }, [])

    //if (isLoading) return <Loader Indicator="Stripe" size="Large" />;
    return <StyledSidebar style={{ width: '100%', height: "100%", border: 'none', backgroundColor: '#FFFFFF', overflow: 'auto', padding: '0' }} position='right'>
        {/* Header part of add or edit record */}
        {memoEditPanelTitleBar}
        {isLoading && <Loader Indicator="Spinner" size="Medium" />}
        {/* Readable and Editable Form */}
        <div className={'add-edit-form'} style={{ height: 'calc(100vh - 125px)', maxHeight: 'calc(100vh - 125px)', overflow: 'auto' }}>
            <div className="flex-row-auto">
                <div className={'flex-row-item'}>
                    <div className={'im-flex-row'}>
                        <div className={'flex-row-item-stretch'}>
                            {/*<SidebarTitle>{!!currentEntity?.tariffCode?currentEntity?.tariffCode : "NEW TARIFF CODE"}</SidebarTitle>*/}

                            {(isAdd || (isEditable && !isRead)) && <SidebarCaption>"All fields are required unless indicated as 'optional'"</SidebarCaption>}
                        </div>
                    </div>

                    <CriteriaItemContainer>
                        {memoBillToCompany}
                        {memoCustomerCode}
                        {memoChargeType}
                    </CriteriaItemContainer>

                    <CriteriaItemContainer>
                        {memoDocType}
                        {memoIssueType}
                    </CriteriaItemContainer>

                    <CriteriaItemContainer>
                        {memoNoOfCopies}
                        {memoNoOfOriginal}
                        {memoNoOfSupportingDoc}
                    </CriteriaItemContainer>

                    <CriteriaItemContainer>
                        {memoInvoiceCurrency}
                        {memoLanguage}
                        {memoAmountPrinting}
                    </CriteriaItemContainer>

                    <CriteriaItemContainer>
                        {memoAsteriskLabel}
                        {memoDisplayBillingMsg}
                        {memoDisplay2ndCurrency}
                    </CriteriaItemContainer>

                    <CriteriaItemContainer>
                        {memoEmailAddress}
                        {memoCc}
                        {memoEdiEmailAddress}
                    </CriteriaItemContainer>

                    <CriteriaItemContainer>
                        {memoReportTemplate}
                        {memoActiveInd}
                    </CriteriaItemContainer>

                </div>
            </div>
        </div>
        {/* Readable and Editable Form */}
    </StyledSidebar>
}